import { NSALoginPage } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";

function LoginPage() 
{
	return (
		<NSALoginPage
			product_id={ProductUUID.NAMIRASOFT_BALANCE}
		/>
	);
}

export default LoginPage;